import { makeStyles } from '@rbx/ui';

const usePageNotFoundStyles = makeStyles()(() => ({
  background: {
    marginTop: 68,
    marginBottom: 68,
  },

  description: {
    marginTop: 6,
  },

  button: {
    marginTop: 24,
  },
}));

export default usePageNotFoundStyles;
